module.exports = __webpack_public_path__ + "media/images/emblems/Rebevelier-coat_of_arms-41f9b6945d126ad6eb3bd482b2effe99.svg";